// src/components/admin/Sidebar.jsx
import { NavLink, useNavigate } from "react-router";
import Cookies from "js-cookie";
import toast from "react-hot-toast";
import oneSignalService from "../../services/oneSignalService";

const navItemBase =
  "flex w-full flex-col items-center justify-center gap-1 rounded-xl text-sm transition-colors duration-200 max-md:flex-1 max-md:px-1 max-md:py-2 md:min-h-[4.5rem] md:w-full md:px-2 md:py-2.5";
const navItemIdle = "text-gray-600 hover:bg-black/[0.06]";
const navItemActive = "bg-white text-violet-700 shadow-sm hover:bg-white";

const getNavLinkClass = (isActive) =>
  `${navItemBase} ${isActive ? navItemActive : navItemIdle}`;

const NavIcon = ({ src, alt }) => (
  <span className="flex h-7 w-6 shrink-0 items-center justify-center">
    <img src={src} alt={alt} className="max-h-6 max-w-6 object-contain" />
  </span>
);

export default function AdminSidebar () {
  const navigate = useNavigate();

  const handleLogout = () => {
    oneSignalService.removeExternalUserId()
      .catch(() => {});

    Cookies.remove("auth_token");
    toast.success("Logged out successfully");
    navigate("/admin/login", { replace: true });
  };

  return (
    <aside className="z-50 flex shrink-0 flex-col bg-gray-100 max-md:fixed max-md:inset-x-0 max-md:bottom-0 max-md:w-full max-md:border-t max-md:border-gray-200 max-md:p-2 max-md:pb-[max(0.5rem,env(safe-area-inset-bottom))] md:sticky md:top-0 md:h-screen md:w-20 lg:w-28 md:border-r md:border-gray-200 md:border-t-0 md:p-3">
      {/* Brand — desktop only */}
      <div className="hidden items-center justify-center gap-2 p-2 md:flex">
        <div className="h-12 w-12">
          <img src="./logo.svg" alt="logo" />
        </div>
      </div>

      {/* Nav */}
      <nav className="flex flex-row items-center justify-between gap-1 md:mt-3 md:flex-col md:justify-start md:gap-0 md:space-y-2">
        <NavLink
          to="/admin/dashboard"
          className={({ isActive }) => getNavLinkClass(isActive)}
        >
          <NavIcon src="../admin/chatbar/report.svg" alt="report" />
          <span className="hidden md:block text-xs leading-tight">Report</span>
        </NavLink>
        <NavLink
          to="/admin-contact"
          className={({ isActive }) => getNavLinkClass(isActive)}
        >
          <NavIcon src="../chatbar/connect.svg" alt="contact" />
          <span className="hidden md:block text-xs leading-tight">Contact</span>
        </NavLink>
        <NavLink
          to="/admin-broadcast"
          className={({ isActive }) => getNavLinkClass(isActive)}
        >
          <NavIcon src="../admin/chatbar/chat.svg" alt="broadcast" />
          <span className="hidden md:block text-xs leading-tight">Broadcast</span>
        </NavLink>
        <NavLink
          to="/admin-chat"
          className={({ isActive }) => getNavLinkClass(isActive)}
        >
          <NavIcon src="../admin/chatbar/chat.svg" alt="inbox" />
          <span className="hidden md:block text-xs leading-tight">Inbox</span>
        </NavLink>
        <NavLink
          to="/revenue"
          className={({ isActive }) => getNavLinkClass(isActive)}
        >
          <NavIcon src="../admin/chatbar/revenue.svg" alt="revenue" />
          <span className="hidden md:block text-xs leading-tight">Revenue</span>
        </NavLink>
        <NavLink
          to="/password-change"
          className={({ isActive }) => getNavLinkClass(isActive)}
        >
          <NavIcon src="../admin/chatbar/profile.svg" alt="profile" />
          <span className="hidden md:block text-xs leading-tight">Profile</span>
        </NavLink>

        {/* Logout — mobile bottom bar */}
        <button
          type="button"
          onClick={handleLogout}
          className={`${navItemBase} ${navItemIdle} md:hidden cursor-pointer border-none bg-transparent`}
          aria-label="Logout"
        >
          <NavIcon src="../chatbar/logout.svg" alt="logout" />
        </button>
      </nav>

      {/* Spacer — desktop only */}
      <div className="hidden flex-1 md:block" />

      {/* Logout — desktop */}
      <button
        type="button"
        onClick={handleLogout}
        className={`${navItemBase} ${navItemIdle} mt-2 hidden cursor-pointer border-none bg-transparent md:flex`}
      >
        <NavIcon src="../chatbar/logout.svg" alt="logout" />
        <span className="hidden md:block text-xs font-medium leading-tight">Logout</span>
      </button>
    </aside>
  );
}
